import { DIALOGS } from '~components/atoms/AbsoluteDialogs';
import { Text } from '~components/atoms/Typography';
import useIsInIframe from '~hooks/useIsInIframe';
import { useTranslation } from '~hooks/useTranslation';
import { useAppDispatch } from '~store';
import { openDialog } from '~store/slices/globalDialogSlice';

export const BetslipLoginToBet = () => {
  const dispatch = useAppDispatch();
  const { localized } = useTranslation();
  const isInIframe = useIsInIframe();

  const textStyles = {
    color: '$white',
    fontSize: '$xxs',
    lineHeight: '$20',
    display: 'inline',
    cursor: 'pointer',
  };

  const linkStyles = {
    margin: '0 $1',
    cursor: 'pointer',
    fontWeight: '$medium',
    textTransform: 'uppercase',
  };

  return (
    <Text css={{ lineHeight: '0' }}>
      <Text as="span" css={{ ...textStyles }}>
        {localized('betslip.warnings.loginToBet')}
      </Text>
      <Text
        as="span"
        underline
        css={{ ...textStyles, ...linkStyles }}
        onClick={() => {
          if (isInIframe) {
            window.parent.postMessage({ type: 'LOGIN' }, '*');
          } else {
            dispatch(openDialog(DIALOGS.SIGN_IN));
          }
        }}
      >
        {localized('buttons.signIn')}
      </Text>
      <Text as="span" css={{ ...textStyles }}>
        {localized('betslip.warnings.or')}
      </Text>
      <Text
        as="span"
        underline
        css={{ ...textStyles, ...linkStyles }}
        onClick={() => {
          if (isInIframe) {
            window.parent.postMessage({ type: 'SIGNUP' }, '*');
          } else {
            dispatch(openDialog(DIALOGS.SIGN_UP));
          }
        }}
      >
        {localized('buttons.register')}.
      </Text>
    </Text>
  );
};
